let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = Promise.all([load("jla9Q"), load("7JjRo"), load("68Kzv"), load("3NvtU"), load("3x2Nh")]).then(() => parcelRequire('kWbha'));